import {useDispatch} from 'react-redux';
import {DispatchHolder} from '@local/logics/global/dispatchHolder';

/**
 * 毎回dispatchをlogic > interactorって渡していくのめんどくさすぎたからグローバルでひとつ持っとく
 */
export const DispatchConnector = () => {
  DispatchHolder.dispatch = useDispatch();
  return null;
};
